<template>
  <div class="flex items-center justify-end gap-8">
    <CountrySwitchMenu class="z-50 hidden w-56 lg:flex" />
    <UserIcon />
    <CartIcon data-test="icon-cart" />
  </div>
</template>

<script setup lang="ts">
import CartIcon from './CartIcon.vue'
import CountrySwitchMenu from './CountrySwitch/CountrySwitchMenu.vue'
import UserIcon from './UserIcon.vue'
</script>
